import { FunctionComponent } from "react";
import styles from "./chip.module.scss";

const Chip: FunctionComponent<{
  children?: any;
  onClick: () => void;
  active: boolean;
}> = ({ children, onClick, active }) => {
  return (
    <button
      onClick={onClick}
      className={`${styles.chip} ${active ? styles.activeChip : ""}`}
    >
      {children}
    </button>
  );
};

export default Chip;
